import { Button, DataSource, Layout, LayoutHeader, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutClientAdmin extends Layout {
    buttonCloseClient: Button;
    layoutheaderClientList: LayoutHeader;
    panelMain: Panel;
    sourceClientAdmin: DataSource;
    tableClientAdmin: Table;
}
